var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsidesImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.28 918.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.77,
    y: 863.66,
    width: 240.43,
    height: 54.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.77 857.65 244.19 857.65 244.19 805.17 75.96 805.17 230.39 725.59 121.93 725.59 3.77 791.09 3.77 857.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.42,632c-19,25.76-26.7,75.19-43.11,79.33C63.24,714.61,50.87,709,46,691.42s3.9-51.14,10.47-62.58L12.88,615s-24.35,45.54-6.09,103.26H139s9.22-68.27,49.19-52.36c19.54,7.78,11,52.36,11,52.36h47s9-56-24.59-90.35S137.72,607.14,119.42,632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.42,24.25c-19,25.76-26.7,75.18-43.11,79.33C63.24,106.88,50.87,101.23,46,83.7s3.9-51.14,10.47-62.59L12.88,7.23S-11.47,52.77,6.79,110.49c0,0,9.34,47.18,63.48,49.13,39.83,1.43,55.22-27.44,64.48-46.43,11.47-23.5,18.63-67.64,53.47-55.06,27,9.73,1.56,100.34,1.56,100.34h49.87s23.22-98.88-18.06-138.33C186.85-13.06,137.72-.58,119.42,24.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.57,
    y: 542.59,
    width: 240.63,
    height: 56.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.76,451.88s-.19,47.57.52,84.56H244.19s.66-14.57.16-48.64c-.41-27.42,3.66-64.37-21.24-110.14-26.18-48.12-80.25-52.62-113-50.63S4,340.92,3.76,451.88Zm123.62-67.69c28,1,55,13.9,66.49,38.51,9.09,19.44,8.65,47.84,8.07,58.95H47.82C46.2,474.07,42,449,51.15,422.5,62.07,390.74,99.39,383.2,127.38,384.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.73 261.94 142.73 175.59 96.4 175.59 96.4 261.94 50.07 261.94 50.07 169.49 3.74 169.49 3.74 317.27 244.54 317.27 244.53 166.09 198.21 166.09 198.21 261.94 142.73 261.94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsidesImg);
export default __webpack_public_path__ + "static/media/insides-img.4a843df4d8e68a86d7802c1c39b47e6f.svg";
export { ForwardRef as ReactComponent };